export const SET_CAREER_DATA = "SET_CAREER_DATA";

export const setCareerData = (data) => ({
  type: SET_CAREER_DATA,
  payload: data,
});
